import React from "react";

import { SkeletonWrapper } from "./styledPaymentPage";
import { Skeleton } from "@mui/material";

export const PaymentInformationSkeleton = () => {
  return (
    <SkeletonWrapper>
      <Skeleton width={200} height={50} />
      <Skeleton width={200} height={40} />
      <Skeleton width={200} height={100} />
      <SkeletonWrapper height={300} width={200}>
        <Skeleton width={200} variant="body1" />
        <Skeleton width={200} variant="body1" />
        <Skeleton width={200} variant="body1" />
        <Skeleton width={200} variant="body1" />
      </SkeletonWrapper>
    </SkeletonWrapper>
  );
};

export const WalletBalanceSkeleton = () => {
  return (
    <span className="mx-auto mx-lg-0 mt-2 mt-lg-0 w-auto d-flex flex-row align-items-center">
      <Skeleton width={30} height={30} variant="circular"/>
      <Skeleton width={50} height={10} className="mx-1"/>
    </span>
  );
};